import { render } from "./RewardListResultModal.vue?vue&type=template&id=1256e9f9"
import script from "./RewardListResultModal.vue?vue&type=script&lang=js"
export * from "./RewardListResultModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__